import { CattownStorage } from "./cattown-storage";
import {AppType, Character, CharacterType, Language, Municipal} from "./types";

export class CattownUser extends CattownStorage{

    getData(){ 
        return super.getData() 
    }
    
    getLanguage(){ 
        return super.getDataUser().language 
    }

    getMunicipal(){ 
        return (this.getData().user.municipal || '') as Municipal 
    }

    getSelectedCity(){
        return this.getMunicipal();
    }

    getPreferredCatType(): CharacterType | null {
        const dataUser = this.getDataUser();
        return dataUser.interact_with_cat_type || 'geek';
    }

    getAppType(): AppType{
        return super.getData().app_type || 'web';
    }

    setLanguage(language: Language): void {
        super.setLanguage(language)
    }

    listCompledScreens(){
        return this.getData().completed_screens;
    }

    setMunicipal(municipal: Municipal): void {
        super.setMunicipal(municipal)
    }

    setCharacter(character: Character): void {
        super.setCharacter(character)
    }

    setCharacterType(type: CharacterType){
        super.setCharacterType(type)
    }

    setCurrentScreen(screen: string): void {
        super.setCurrentScreen(screen)
    }

    setAppType(app_type: AppType): void {
        super.setAppType(app_type)
    }

    screenCompleted(){
        const screensCompleted = this.getData().completed_screens;
        const screen = window.location.pathname;
        if(!screensCompleted.includes(screen)) screensCompleted.push(screen);

        super.setScreensCompleted(screensCompleted);
    }

}

export function getUserLanguage(): Language {
    const cattownUser = new CattownUser();
    return cattownUser.getLanguage();
}

export function getUserCity(): Municipal {
    const cattownUser = new CattownUser();
    return cattownUser.getSelectedCity();
}

export function getUserPreferredCatType(): CharacterType | null {
    const cattownUser = new CattownUser();
    return cattownUser.getPreferredCatType()
}

export function getUserAppType(): AppType {
    const cattownUser = new CattownUser();
    return cattownUser.getAppType();
}